import WhatsAppVerify from "./WhatsAppVerify";
import "./whatsappOnboarding.css";

/**
 * Shown once, after a user first lands in the app authenticated, nudging them to
 * verify their WhatsApp. Deliberately SKIPPABLE — verification is enforced at the
 * point of publishing a ride, not here, so a listener outage (or a passenger who
 * only books) never gets stuck behind this. See server/utils/publishGate.js.
 */
function WhatsAppOnboardingModal({ onVerified, onSkip }) {
  return (
    <div className="sr-waonboard__overlay" role="dialog" aria-modal="true">
      <div className="sr-waonboard__card">
        <WhatsAppVerify
          title="Verify your WhatsApp"
          subtitle="Link the rides you post in WhatsApp groups to your profile, unlock private-group rides, and post your own — all with one quick check. We never message you first."
          onVerified={onVerified}
        />
        <button type="button" className="sr-waonboard__skip" onClick={onSkip}>
          Skip for now
        </button>
      </div>
    </div>
  );
}

export default WhatsAppOnboardingModal;
